export default __webpack_public_path__ + "static/media/actions-portfile-icon.89f8615d.png";